import { type Instant, ZoneId } from "@js-joda/core";
import React, { useMemo } from "react";
import "@js-joda/timezone";
import { Formatter } from "./Formatter";
import { useDateTimeFormatContext } from "src/app/hooks/useDateTimeFormatContext";
import { ConvertToInstant } from "src/utilities/DateUtils";

export interface IFormattedInstantProps {
  value: Instant;
  zoneId?: ZoneId;
}

const FormattedInstant = ({ value, zoneId }: IFormattedInstantProps) => {
  const { dateTimeFormatter } = useDateTimeFormatContext();
  return <>{value.atZone(zoneId || ZoneId.SYSTEM).format(dateTimeFormatter)}</>;
};
export default FormattedInstant;

export interface IFormattedInstantStringProps
  extends Omit<IFormattedInstantProps, "value"> {
  value: string;
}

export const FormattedInstantString = ({
  value,
  ...rest
}: IFormattedInstantStringProps) => {
  const instant = useMemo(
    () => (value ? ConvertToInstant(value) : undefined),
    [value],
  );
  if (!instant) {
    return <Formatter>{undefined}</Formatter>;
  }
  return <FormattedInstant value={instant} {...rest} />;
};
